// extracted by mini-css-extract-plugin
export default {"failure":"failure_failure__3tNEn","button":"failure_button__J2sxv"};